// extracted by mini-css-extract-plugin
var _1 = "confirmation__eYVSH";
export { _1 as "confirmation" }
